import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { action: "#" }
const _hoisted_2 = { class: "token-box" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "persist-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.token) = $event)),
        placeholder: $setup.i18n('ENTER_TOKEN') + $setup.store.connection.NAME,
        style: {"width":"100%"}
      }, null, 8 /* PROPS */, _hoisted_3), [
        [_vModelText, $setup.token]
      ]),
      _createElementVNode("button", {
        onClick: $setup.setToken,
        type: "submit",
        disabled: $setup.token.length == 0
      }, _toDisplayString($setup.i18n('SAVE').toUpperCase()), 9 /* TEXT, PROPS */, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.persist) = $event)),
        onClick: $setup.togglePersist
      }, null, 512 /* NEED_PATCH */), [
        [_vModelCheckbox, $setup.persist]
      ]),
      _createTextVNode(_toDisplayString($setup.i18n('AUTH_PERSIST')), 1 /* TEXT */)
    ])
  ]))
}